import { TopTenWidget } from '@/types'
import Container from '../Container'
import { Heading } from '@big-red-group/storefront-common-ui'
import ImageContent from './blog/ImageContent'
import Paragraph from './blog/Paragraph'

type TopTenThingsProps = {
  widget: TopTenWidget
  entityName: string
}

const TopTenThings: React.FC<TopTenThingsProps> = ({ widget, entityName }) => {
  return (
    <Container spacing="XXL">
      <Heading size="XL">Top 10 Things to do {entityName}</Heading>
      <Paragraph text={widget.intro} />
      {widget.things.map((thing, index) => {
        const isReverse = index % 2 === 1
        return (
          <>
            <ImageContent
              image={thing.image}
              key={index}
              heading={`${thing.order}. ${thing.title}`}
              text={thing.text}
              reverse={isReverse}
              link={thing.link}
              truncateText
            />
          </>
        )
      })}
    </Container>
  )
}

export default TopTenThings
